<template>
  <div>
    <div v-if="this.company" class="menu-items">
      <a
        v-if="this.company.role === 'FAC'"
        href="/company/search"
        class="search-icon"
        :class="this.menuSelected.companySearch && 'search-active'"
        >{{ $t("searchName") }}</a
      >
      <a
        href="/customer/dashboard"
        class="dashboard"
        :class="this.menuSelected.dashboard && 'dashboard-active'"
        >{{ $t("dashboardName") }}</a
      >
      <a
        href="/customer/orders"
        class="orders"
        :class="this.menuSelected.orders && 'orders-active'"
        >{{ $t("ordersName") }}</a
      >
      <a
        href="/customer/beneficiaries"
        class="beneficiaries"
        :class="this.menuSelected.beneficiaries && 'beneficiaries-active'"
        >{{ $t("beneficiariesName") }}</a
      >
      <a
        href="/customer/delivery_points"
        class="points"
        :class="this.menuSelected.deliveryPoints && 'points-active'"
        >{{ $t("deliveryPointsName") }}</a
      >
      <a
        v-if="this.company.role !== 'FAC'"
        href="/customer/contact"
        class="contact"
        :class="this.menuSelected.contact && 'contact-active'"
        >{{ $t("contactName") }}</a
      >
      <a
        v-if="this.company.role !== 'FAC'"
        href="/customer/terms"
        class="term"
        :class="this.menuSelected.terms && 'term-active'"
        >{{ $t("termsAndConditionsName") }}</a
      >
      <!-- <a
        href="/customer/gdpr"
        class="policy"
        :class="this.menuSelected.gdpr && 'policy-active'"
      >{{$t("personalDataPolicyName")}}</a>-->

      <a href="#" class="logout" @click="logout()">{{ $t("logoutName") }}</a>
    </div>
    <a href="/customer/new_order" class="notification-action">
      {{ $t("newOrderName") }}
    </a>
    <div class="socials">
      <a
        href="https://www.facebook.com/uphellas/"
        class="facebook"
        target="_blank"
      ></a>
      <a
        href="https://www.linkedin.com/company/up-hellas"
        class="linkedin"
        target="_blank"
      ></a>
      <a
        href="https://www.instagram.com/up_hellas/?hl=en"
        class="instagram"
        target="_blank"
      ></a>
    </div>

    <div class="gecr">
      {{ $t("gecrNumber") }}
    </div>
  </div>
</template>
<script>
import utils from "@/plugins/utils.js";
import Cookies from "js-cookie";

export default {
  name: "MenuItemsCustomer",
  props: {
    menuSelected: {
      dashboard: false,
      beneficiaries: false,
      orders: false,
      deliveryPoints: false,
      newOrder: false,
      faq: false,
      account: false,
      contact: false,
      terms: false,
      gdpr: false,
      companySearch: false,
    },
  },
  data() {
    return {
      company: null,
    }
  },
  methods: {
    logout() {
      utils.logout();
    },
    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push("/");
    },
  },
  created() {
    this.company =  JSON.parse(sessionStorage.getItem("selectedCompany"));

    // this.company = Cookies.getJSON("selectedCompany");
  }
};
</script>
<style scoped src="@/assets/styles/beneficiary.css"></style>
